/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/Spinner';
import DeleteCheckLogDiscrepancies from './components/DeleteCheckLogDiscrepancies';
import DeleteCheckLogHeader from './components/DeleteCheckLogHeader';
import {
  getRebateProgramCode,
  setDeleteCheckLogFilterValue,
  setErrorMessages,
} from './store/action';
import { PLAN_TYPE_DATA } from './utils/constant';

const DeleteCheckLog = () => {
  const dispatch = useDispatch();
  const [discrepancies, setDiscrepancies] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const loading = useSelector(
    (state) => state.sharedState.deleteCheckLog.loading
  );

  const userDefault = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const deleteCheckLogFilter = useSelector(
    (state) => state.sharedState.deleteCheckLog.deleteCheckLogFilter
  );

  const rebateDropdownData = useSelector(
    (state) => state.sharedState.deleteCheckLog.rebateDropdownData
  );

  const errorMessages = useSelector(
    (state) => state.sharedState.deleteCheckLog.errorMessages
  );

  const handleErrorMessages = useCallback(
    (messages) => {
      dispatch(setErrorMessages(messages));
    },
    [errorMessages]
  );

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/deleteCheckLog') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  useEffect(() => {
    if (!deleteCheckLogFilter || !deleteCheckLogFilter.rpc) {
      if (rebateDropdownData && rebateDropdownData.length > 0 && userDefault) {
        const filterArr = rebateDropdownData.filter(
          (item) => item.value === userDefault.rebateProgramCd
        );

        if (filterArr.length > 0) {
          dispatch(setDeleteCheckLogFilterValue('rpc', filterArr[0].value));
          dispatch(
            setDeleteCheckLogFilterValue(
              'checkPayeeCd',
              filterArr[0].checkPayeeCd
            )
          );
        }
      }
    }
  }, [rebateDropdownData, userDefault]);

  useEffect(() => {
    if (
      userDefault &&
      (!deleteCheckLogFilter || !deleteCheckLogFilter.planType)
    ) {
      if (userDefault.planTypeCd) {
        dispatch(
          setDeleteCheckLogFilterValue('planType', userDefault.planTypeCd)
        );
      } else {
        dispatch(
          setDeleteCheckLogFilterValue('planType', PLAN_TYPE_DATA[0].value)
        );
      }
    }
  }, [userDefault]);

  useEffect(() => {
    if (deleteCheckLogFilter && deleteCheckLogFilter.planType) {
      dispatch(getRebateProgramCode(deleteCheckLogFilter.planType));
    }
  }, [deleteCheckLogFilter && deleteCheckLogFilter.planType]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}

      <CustomSeparator
        parent1={'System'}
        parent2={'Technical Window'}
        parent3={'Online Fixes'}
        parent4={'Request Delete Check Log'}
      />

      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}

      <DeleteCheckLogHeader
        searchFilter={deleteCheckLogFilter}
        rebateData={rebateDropdownData}
        setErrorMessages={handleErrorMessages}
        setSuccessMessages={setSuccessMessages}
        setDiscrepancies={setDiscrepancies}
      />

      {discrepancies && discrepancies.length > 0 && (
        <div className="row">
          <div className="col-12">
            <DeleteCheckLogDiscrepancies data={discrepancies} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteCheckLog;
